import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { isEndWithConsonant } from "../../../utils/status";

const CommunityRecommend = ({ type, categoryList }) => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	// const [mediaResult, setMediaResult] = useState(null);
	// useEffect(() => {
	//     if (typeof window !== 'undefined') {
	//         const matchQueryList = window.matchMedia('all and (max-width: 768px)');
	//         setMediaResult(matchQueryList.matches);
	//
	// const media = function handleChange(e) {
	// 	setMediaResult(e.matches);
	// };
	//
	// matchQueryList.addEventListener("change", media);
	//     }
	// }, []);

	return (
		<>
			<div className={`community-recommend home-channel-triple-each`}>
				<p className={`recommend-category-title`}>고민별</p>
				<p className={`title`}>
					{reduxChannel?.name}
					{isEndWithConsonant(reduxChannel?.name) ? "이" : "가"} 정리한{"\n"}
					고민별 정보
				</p>
				<div className={`recommend-list-group`}>
					{categoryList?.map((item, idx) => (
						<div
							className={`recommend-each`}
							style={{
								// backgroundColor: item?.bg_color,
								background: `${
									item?.bg_color
								} no-repeat right bottom /100% url("${
									process.env.REACT_APP_HOST
								}/assets/images/channel/recommend-${idx % 2 ? 2 : 0}.png")`,
							}}
							key={`recommend ${type} ${idx}`}
							onClick={() =>
								history.push(
									`/together/channel/${type}s/detail/${
										item[`${type === "combination" ? `id` : `${type}_id`}`]
									}?id=` + reduxChannel?.influencer_id
								)
							}
						>
							<div className={`recommend-category-name-div`}>
								{type === "combination" ? (
									<p className={`category-name`}>{item?.category_name}</p>
								) : (
									<p className={`category-name`}>{item[`${type}_name`]}</p>
								)}
								<img
									src={`/assets/images/channel/line-arrow-icon.png`}
									alt={`이미지 홈 성분별`}
									style={{
										height: "2em",
										width: "auto",
									}}
								/>
							</div>

							{item.is_hot && (
								<img
									src={`/assets/images/channel/hot-squid.png`}
									alt={`이미지 홈 성분별`}
									className={`channel-point`}
								/>
							)}

							{item.is_best && (
								<img
									src={`/assets/images/channel/best-squid.png`}
									alt={`이미지 홈 성분별`}
									className={`channel-point`}
								/>
							)}
						</div>
					))}
				</div>
				<Link
					to={`/together/channel/${type}s?id=${reduxChannel?.influencer_id}`}
					className={`recommend-button`}
					style={{
						height: "auto",
						marginTop: "2em",
					}}
				>
					전체보기
				</Link>
			</div>
		</>
	);
};
export default CommunityRecommend;
